import {Button, Modal, QRCode, Spin} from 'antd'
import {ReloadOutlined} from "@ant-design/icons";

/**
 * 签约二维码
 * @param props
 * @returns
 */
const QRcodeModal = (props: {
    visible: boolean;
    onClose: () => void;
    reloadFn: () => void;
    signLink: string,
    loading?: boolean
}) => {
    const {visible, onClose, reloadFn, signLink, loading} = props

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            width={400}
            footer={null}
            // closeIcon={null}
            maskClosable={false}
            destroyOnClose={true}
        >
            <Spin spinning={loading}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '40px 0 20px',
                    }}
                >
                    {signLink ? <>
                        <QRCode
                            value={signLink}
                            type="svg"
                            size={320}
                            bordered={false}
                            style={{padding: 0, borderRadius: 0}}
                        />
                        <div style={{marginTop: 20}}>
                            签约二维码
                        </div>
                    </> : <>
                        <div style={{marginBottom: 20}}>
                            获取二维码失败请重试
                        </div>
                        <Button icon={<ReloadOutlined/>} loading={loading} onClick={reloadFn}/>
                    </>}
                </div>
            </Spin>
        </Modal>
    )
}

export default QRcodeModal
